module.exports = __webpack_public_path__ + "static/media/less-waste@2x.a8472ffc.jpg";